
import React from "react";
import "./Dashboards.css";
import { useNavigate } from "react-router-dom";
import {
  FaHandHoldingUsd,
  FaClock,
  FaCashRegister,
  FaHandshake,
  FaExclamationTriangle,
  FaUser,
  FaFileInvoice,
  FaUserTie,
  FaMoneyBill,
  FaUserSlash,
} from "react-icons/fa";
import { MdOutlineRule } from "react-icons/md";
const Dashboard = () => {
const navigate = useNavigate();
const branches = [
    { name: "Branch 1", collection: 10, disbursement: 10, pending: 10, npa: 0 },
    { name: "Branch 2", collection: 20, disbursement: 20, pending: 20, npa: 0 },
    { name: "Branch 3", collection: 30, disbursement: 30, pending: 30, npa: 0 },
    { name: "Branch 4", collection: 40, disbursement: 40, pending: 40, npa: 0 },
  ];

  const data={
    coll:"30000",
    disb:"20000",
    pen:"10000",
  }

  
  return (
    <div className="demo-container">
      {/* HEADER */}
      {/* <h2>Techvision</h2> */}
          <div className="demo-filter-box">
        <input
          type="text"
          placeholder="Search customer,transaction..."
        
        />
        <select>
          <option value="">All Branches</option>
          <option value="demo-branch">Branch 1</option>
          <option value="demo-branch">Branch 2</option>
          <option value="demo-branch">Branch 3</option>
          <option value="demo-branch">Branch 4</option>
        </select>

        <select>
          <option value="">Branch Date</option>
          <option value="demo-Date">Today</option>
          <option value="demo-Date">This Week</option>
          <option value="demo-Date">Last 30 days</option>
          <option value="demo-Date">This Quarter</option>
          <option value="demo-Date">This Year</option>
        </select>
      </div>
        
      

        <div className="boxes-container">
          <div className="half-box-vertical">
      <div className="top-small">
        <p>This Month</p>
      </div>
      <div className="bottom-large">
      <h2 className="demo-collection-header">Collection </h2>
      
      <p>23491</p>
      </div>
      </div>


      <div className="half-box-vertical">
      <div className="top-small">
        <p>This Month</p>
      </div>
      <div className="bottom-large">
      <h2 className="demo-disbursement-header">Disbursement</h2>
      <p>23491</p>
      </div>
      </div>

      <div className="half-box-vertical">
      <div className="top-small">
        <p>This Month</p>
      </div>
      <div className="bottom-large">
      <h2 className="demo-pending-header">Pending Collection</h2>
      <p>23491</p>
      </div>
      </div>
      

      <div className="half-box-vertical">
      <div className="top-small">
        <p>This Month</p>
      </div>
      <div className="bottom-large">
      <h2 className="demo-pendingdisb-header">Pending Disbursement</h2>
      <p>23491</p>
      </div>
      </div>
    </div>


  
      


     <div className="demo-sections">
  {/* LEFT SECTION */}
  <div className="demo-left-section cardBox">
    <h4>Key ledgers</h4>
    <h2>Balance Snapshot</h2>
   <div className="demo-balance-grid">
      <div className="demo-balance-branches">Total Branches<br /> 00</div>
      <div className="demo-balance-total">Total<br />00</div>
      <div className="demo-balance-cash">Cashbook<br />00</div>
      <div className="demo-balance-bank">Bankbook<br />00</div>
      <div className="demo-balance-charges">Charges<br />00</div>
      <div className="demo-balance-coll">Collection<br />00</div>
      <div className="demo-balance-disb">Disbursement<br />00</div>
      <div className="demo-balance-outs">Outstanding<br />00</div>
    </div>

  </div>
  {/* RIGHT SECTION */}
  <div className="demo-right-section cardBox">
    <h4>Navigate fast</h4>
    <h2>Quick Actions</h2>
    <div className="demo-quick-grid">
      <button className="demo-action-btn-cus">Customer</button>
      <button className="demo-action-btn-emp">Employee</button>
      <button className="demo-action-btn-loan">Loan</button>
      <button className="demo-action-btn-coll">Collection</button>
      <button className="demo-action-btn-report">Due Report</button>
      <button className="demo-action-btn-scheme">Loan Scheme</button>
    </div>
    </div>
          
          {/* Task & Alert */}

          <div className="demo-tasks-alerts-card">
      <p className="demo-top-heading">Operational</p>
      <h3 className="demo-main-title">Tasks & Alerts</h3>

      <div className="demo-task-item">
        <div>
          <p className="demo-task-title">pending disbursements</p>
          <p className="demo-task-desc">Review and approve before EOD.</p>
        </div>
        <button className="demo-task-btn">Review</button>
      </div>

      <hr />

      <div className="demo-task-item">
        <div>
          <p className="demo-task-title">KYC updates required</p>
          <p className="demo-task-desc">Customers with expired documents.</p>
        </div>
        <button className="demo-task-btn">Update KYC</button>
      </div>
      </div>    
  </div>

  
          



      {/* TRANSACTIONS */}
      <div className="demo-two-column">

  {/* LEFT SIDE – TRANSACTIONS TABLE */}
  <div className="demo-transactions-section">
    <div className="demo-transaction-header">
      <h3>Latest Transactions</h3>
    </div>

    <table>
      <thead>
        <tr>
          <th>Branch</th>
          <th>Collection</th>
          <th>Disbursement</th>
          <th>Pending</th>
          <th>NPA (%)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Branch 1</td>
          <td className="demo-red">100</td>
          <td className="demo-green">100</td>
          <td className="demo-orange">$90.0</td>
          <td className="demo-black">0%</td>
        </tr>
        <tr>
          <td>Branch 2</td>
          <td className="demo-red">100</td>
          <td className="demo-green">100</td>
          <td className="demo-orange">$90.0</td>
          <td className="demo-black">0%</td>
        </tr>
        <tr>
          <td>Branch 3</td>
          <td className="demo-red">100</td>
          <td className="demo-green">100</td>
          <td className="demo-orange">$90.0</td>
          <td className="demo-black">0%</td>
        </tr>
      </tbody>
    </table>
  </div>

  {/* RIGHT SIDE – PIE SUMMARY */}
  <div className="demo-pie-summary-card">
    <div className="demo-ppie-header-row">
      <h3>Summary</h3>
      <button className="demo-pie-view-btn">View Report</button>
    </div>

    <p className="demo-pie-date-text">Data from 1–12 Apr, 2024</p>

    <div className="demo-pie-content-row">
      <div className="demo-donut-wrap">
        <div className="demo-pie-donut">
          <div className="demo-pie-center-text">
            <h2>$8,295</h2>
            <span className="demo-pie-percent">↓ 2.1%</span>
          </div>
        </div>
      </div>

      <div className="demo-pie-legend">
        <div className="demo-pie-item">
          <span className="demo-pie-pink"></span> Collection <span className="demo-pie-coll-value">18%</span>
        </div>
        <div className="demo-pie-item">
          <span className="demo-pie-green"></span> Disbursement <span className="demo-pie-disb-value">73%</span>
        </div>
        <div className="demo-pie-item">
          <span className="demo-pie-orange"></span> Pending <span className="demo-pie-pending-value">9%</span>
        </div>
      </div>
    </div>
  </div>
</div>




      {/* Latest TRANSACTIONS */}
      <div className="demotwo-transactions-section">
        <h3>Recent Transactions  & Latest Activity </h3>
        
        <table>
          <thead>
            <tr>
              <th>Txn ID</th>
              <th>Type</th>
              <th>Party</th> 
              <th>Amount</th>
              <th>Branch</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>TXN-98231</td>
              <td className="demotwo-red"><span>Collection</span></td>
              <td>Rahul Kumar</td>
              <td className="demotwo-red">- $90.0</td>
              <td>Branch 1</td>
              <td>10:22 AM</td>
            </tr>
            <tr>
              <td>TXN-98231</td>
              <td className="demotwo-green"><span>Disbursement</span></td>
              <td>Rahul Kumar</td>
              <td className="demotwo-green">- $90.0</td>
              <td>Branch 1</td>
              <td>10:22 AM</td>
            </tr>
            <tr>
              <td>TXN-98231</td>
              <td className="demotwo-orange">Charge</td>
              <td>Rahul Kumar</td>
              <td className="demotwo-orange">- $90.0</td>
              <td>Branch 1</td>
              <td>10:22 AM</td>
            </tr>
          </tbody>
        </table>
      </div>
 
    </div>
  );
};

export default Dashboard;


